var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6 10.4132L14.491 14.3042L13.643 15.1532L9.4 10.9102V4.91016H10.6V10.4132ZM10 20.9102C4.477 20.9102 0 16.4332 0 10.9102C0 5.38716 4.477 0.910156 10 0.910156C15.523 0.910156 20 5.38716 20 10.9102C20 16.4332 15.523 20.9102 10 20.9102ZM10 19.7102C12.3339 19.7102 14.5722 18.783 16.2225 17.1327C17.8729 15.4824 18.8 13.2441 18.8 10.9102C18.8 8.57625 17.8729 6.33794 16.2225 4.68762C14.5722 3.0373 12.3339 2.11016 10 2.11016C7.66609 2.11016 5.42778 3.0373 3.77746 4.68762C2.12714 6.33794 1.2 8.57625 1.2 10.9102C1.2 13.2441 2.12714 15.4824 3.77746 17.1327C5.42778 18.783 7.66609 19.7102 10 19.7102Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeSchedule);
export default __webpack_public_path__ + "static/media/ChangeSchedule.b0ddeab19f1db4454ae999a50b556d38.svg";
export { ForwardRef as ReactComponent };